import FilePickerAction from '../store/schema/FilePickerAction';
import {
    AttachOrSharePreference,
    FilePickerUserConfigurationProperty,
} from '../store/schema/FilePickerUserConfiguration';

export default function getUserPreferredFilePickerAction(
    actionPreference: FilePickerUserConfigurationProperty<AttachOrSharePreference>
): FilePickerAction {
    if (!actionPreference) {
        return null;
    }

    switch (actionPreference.value) {
        case AttachOrSharePreference.Attach:
            return FilePickerAction.Attach;
        case AttachOrSharePreference.Share:
            return FilePickerAction.Share;
        default:
            return null;
    }
}
